import type { OperationsApartmentTurnover } from '@/shared/api';
import type { HeuteDay } from './heuteDayModel';
import { formatCalendarDate } from './operationsDate';

/**
 * Unter den Bahnen: wer bleibt, Aufenthalte in anderen Phasen (beide öffnen die Details) und
 * welche Apartments ruhig sind.
 */
export function HeuteLaneFooter({
  day,
  onOpen,
}: {
  day: HeuteDay;
  onOpen: (apartment: OperationsApartmentTurnover, trigger: HTMLElement) => void;
}) {
  if (day.staying.length === 0 && day.others.length === 0 && day.quiet.length === 0) return null;
  return (
    <div className="border-hairline flex flex-wrap items-center gap-2 border-t pt-3 text-[13px]">
      {day.staying.length > 0 && <span className="text-ink-soft font-bold">Bleiben</span>}
      {day.staying.map(({ apartment, guest, until }) => (
        <button
          key={apartment.propertyId}
          type="button"
          onClick={(event) => onOpen(apartment, event.currentTarget)}
          className="bg-forest-soft text-ink rounded-pill flex h-9 items-center gap-2 px-3 font-semibold"
        >
          <span className="font-serif font-bold">{apartment.adminDisplayName}</span>
          <span>{guest}</span>
          <span className="text-ink-soft">
            bis {formatCalendarDate(until)}
            {apartment.isManuallyBlocked ? ' · gesperrt' : ''}
          </span>
        </button>
      ))}
      {day.others.map(({ apartment, guest, phase }) => (
        <button
          key={`${apartment.propertyId}-${guest}-${phase}`}
          type="button"
          onClick={(event) => onOpen(apartment, event.currentTarget)}
          className="bg-card-alt text-ink rounded-pill flex h-9 items-center gap-2 px-3 font-semibold"
        >
          <span className="font-serif font-bold">{apartment.adminDisplayName}</span>
          <span>{guest}</span>
          <span className="text-ink-soft">· {phase}</span>
        </button>
      ))}
      {day.quiet.length > 0 && (
        <span className="text-ink-soft ml-auto">
          Ruhig:{' '}
          {day.quiet
            .map((a) => `${a.adminDisplayName}${a.isManuallyBlocked ? ' (manuell gesperrt)' : ''}`)
            .join(', ')}
        </span>
      )}
    </div>
  );
}
